import React from "react";
import "us.collection.economy/components/ClientOrders/Home.scss";
import { IOrder } from "us.collection.economy/components/ClientOrders/Interfaces";
import { IOrderList } from "./interface";
import { OrderItem } from "./Components";

const OrderList: React.FC<IOrderList> = ({
  orders,
  selectedOrders,
  onSelectOrder,
  onDeleteOrder,
}) => {
  return (
    <div className="order-item">
      {orders?.map((order: IOrder) => {
        return (
          <OrderItem
            key={order.orderNo}
            order={order}
            selectedOrders={selectedOrders}
            onSelectOrder={onSelectOrder}
            onDeleteOrder={onDeleteOrder}
          />
        );
      })}
    </div>
  );
};

export default OrderList;
